import Downloads from './Downloads.i18n';

export default Downloads
export { Downloads as Base }